<template>
  <svg
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.25 0.5C13.207 0.5 14 1.29297 14 2.25V9.25C14 10.2344 13.207 11 12.25 11H1.75C0.765625 11 0 10.2344 0 9.25V2.25C0 1.29297 0.765625 0.5 1.75 0.5H12.25ZM1.75 1.8125C1.50391 1.8125 1.3125 2.03125 1.3125 2.25V2.87891L5.85156 6.65234C6.48047 7.17188 7.49219 7.17188 8.12109 6.65234L12.6875 2.87891V2.25C12.6875 2.03125 12.4688 1.8125 12.25 1.8125H1.75ZM12.25 9.6875C12.4688 9.6875 12.6875 9.49609 12.6875 9.25V4.57422L8.94141 7.69141C8.39453 8.12891 7.71094 8.375 7 8.375C6.26172 8.375 5.57812 8.12891 5.03125 7.69141L1.3125 4.57422V9.25C1.3125 9.49609 1.50391 9.6875 1.75 9.6875H12.25Z"
      :fill="props.fill"
    />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  fill: {
    type: String,
    default: '#000000',
  },
});
</script>
